import {useEffect,useRef} from 'react';
export default function Dialog({open,onClose,busy=false,children,...props}) {
  const ref=useRef(null);
  useEffect(()=>{if(open&&!ref.current.open)ref.current.showModal();if(!open&&ref.current.open)ref.current.close();},[open]);
  return <dialog {...props} ref={ref} onCancel={e=>{if(busy)e.preventDefault();}} onClose={()=>onClose?.()}>{children}</dialog>;
}
export function dialogBinding(open,onClose,busy=false) {return {ref:node=>{if(node){if(open&&!node.open)node.showModal();if(!open&&node.open)node.close();}},onClose:e=>{if(!e.currentTarget.open)onClose?.();},onCancel:e=>{if(busy)e.preventDefault();}};}
